import { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  findNodeById,
  generateCustomCss,
  renderValidatedEditorNode,
} from '../../../NewBlogSystem/utilities/htmlEditorUtils.js';
import {
  generatePortfolioFontThemeCss,
  withoutFontThemeDefinition,
} from '../../../NewBlogSystem/utilities/googleFonts.js';
import AiRecordUpdateReview from './AiRecordUpdateReview.jsx';

const AiAssistantPreview = ({ preview, onExpand }) => {
  const document = preview.afterDocument;
  const root = preview.focusedNodeId
    ? findNodeById(document?.root, preview.focusedNodeId)
    : document?.root;
  const previewCss = useMemo(() => [
    generateCustomCss(withoutFontThemeDefinition(document?.classes || {})),
    generatePortfolioFontThemeCss(document?.classes || {}),
  ].filter(Boolean).join('\n\n'), [document?.classes]);

  return (
    <article className="ai-assistant-inline-preview" aria-label="Proposed changes preview">
      <header>
        <div>
          <span>Ready to review</span>
          <strong>{preview.title}</strong>
        </div>
        <button
          className="btn btn-sm btn-outline-primary"
          type="button"
          onClick={onExpand}
          aria-label="Expand preview"
          title="Expand preview"
        >
          <i className="bi bi-arrows-fullscreen" aria-hidden="true"></i>
        </button>
      </header>
      <div
        className="ai-assistant-inline-preview-viewport"
        aria-hidden="true"
        inert={true}
        onClickCapture={(event) => event.preventDefault()}
      >
        {previewCss ? <style>{previewCss}</style> : null}
        <div className="html-editor-canvas">
          {root ? renderValidatedEditorNode(root) : (
            <div className="text-muted text-center p-3">No previewable content</div>
          )}
        </div>
      </div>
      {preview.summary.schema.hasChanges ? (
        <div className="ai-assistant-inline-preview-warning">
          <i className="bi bi-exclamation-triangle" aria-hidden="true"></i>
          Includes layout changes
        </div>
      ) : null}
      {preview.summary.recordChanges > 0 ? (
        <AiRecordUpdateReview
          updates={preview.recordUpdates}
          context={preview.recordContext}
        />
      ) : null}
    </article>
  );
};

AiAssistantPreview.propTypes = {
  preview: PropTypes.shape({
    title: PropTypes.string.isRequired,
    afterDocument: PropTypes.object.isRequired,
    focusedNodeId: PropTypes.string,
    summary: PropTypes.object.isRequired,
    recordUpdates: PropTypes.object,
    recordContext: PropTypes.object,
  }).isRequired,
  onExpand: PropTypes.func.isRequired,
};

export default AiAssistantPreview;
